<template>
  <section>
    <div class="header-details">
      <h1>Dashboard</h1>
      <font-awesome-icon icon="arrow-right" class="icon-title" />
      <h1> {{ $route.params.nameProyect }}</h1>
    </div>
    <FasesIndicatorVue />
    <ProcessIndicatorVue  />
    <ProcessVue  />
  </section>
</template>

<script>
import FasesIndicatorVue from "@/components/ViewProject/FasesIndicator.vue";
import ProcessIndicatorVue from "@/components/ViewProject/ProcessIndicator.vue";
import ProcessVue from "../components/ViewProject/Process/Process";
import { mapGetters, mapMutations } from "vuex";

export default {
  components: {
    FasesIndicatorVue,
    ProcessIndicatorVue,
    ProcessVue,
  },
  data: () => ({}),
  computed: {
    ...mapGetters([
      "getPhaseSelected",
      "getPhaseActive",
      "getProcessSelected",
      "getSubProcessSelected",
    ]),
  },
  methods: {
    ...mapMutations([
      "setPhaseSelected",
      "setProcessSelected",
      "setSubProcessSelected",
    ]),
  },
  created() {
    if (!this.getPhaseSelected) {
      this.setPhaseSelected(this.getPhaseActive.id);
    }
    if (!this.getProcessSelected) {
      this.setProcessSelected(this.getPhaseSelected.process[0].id);
    }
    if (!this.getSubProcessSelected) {
      this.setSubProcessSelected(this.getProcessSelected.SubProcess[0].name);
    }
  },
};
</script>

<style>
.header-details .icon-title {
  color: var(--third-color);
  font-size: 1.3rem;
  margin: 0 10px;
  align-self: flex-end;
  transform: translateY(-2.5px);
}
.header-details h1:first-child {
  font-size: 1rem;
  transform: translateY(-2.5px);
}
.header-details h1 {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  margin-bottom: 0;
  font-weight: bold;
  font-size: 0.8rem;
  transform: translateY(-3px);
}
.container-details {
  display: flex;
  width: 100%;
  justify-content: center;
}
/*=============================================
MOVIL (XS revisamos en 320px)
=============================================*/

@media (max-width: 767px) {
  .header-details .icon-title {
    transform: translateY(-5px);
  }
  .header-details h1:first-child {
    font-size: 0.8rem;
    transform: translateY(4px);
  }
  .header-details h1 {
    font-size: 0.65rem;
  }
}
</style>
